'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dKind$0024 from "./presto.types$-Credential-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_SitesView$$anon$38() {
  this.byn = null;
  this.byl = null;
  this.bym = false;
  this.byj = null;
  this.byk = false;
  this.byo = false;
  this.byp = false;
  this.byn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_SitesView$$anon$38 as $c_Lpresto_SitesView$$anon$38 };
$p = $c_Lpresto_SitesView$$anon$38.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SitesView$$anon$38;
/** @constructor */
function $h_Lpresto_SitesView$$anon$38() {
}
export { $h_Lpresto_SitesView$$anon$38 as $h_Lpresto_SitesView$$anon$38 };
$h_Lpresto_SitesView$$anon$38.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.byn;
});
$p.t = (function() {
  if ((!this.bym)) {
    this.byl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bym = true;
  }
  return this.byl;
});
$p.ad = (function() {
  if ((!this.byk)) {
    this.byj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().gI(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dKind$0024.$m_Lpresto_types$CredentialKind$().Sz(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.byk = true;
  }
  return this.byj;
});
$p.v = (function() {
  if ((!this.byp)) {
    this.byo = false;
    this.byp = true;
  }
  return this.byo;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_SitesView$$anon$38 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SitesView$$anon$38, "presto.SitesView$$anon$38", ({
  S2: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_SitesView$$anon$38 as $d_Lpresto_SitesView$$anon$38 };
//# sourceMappingURL=presto.-Sites-View$$anon$38.js.map
